<template>
  <v-row no-gutters justify="center" align="center">
    <v-progress-circular
      indeterminate
    />
  </v-row>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  name: `Sso`,

  data: () => ({
    isUsernameError: false,
    isPasswordError: false,
    isServerError: false,
    isSubmitting: false,
    logout: true,
  }),

  computed: {
    ...mapState(`model/auth`, [`accessToken`]),
    ssoToken: {
      get() { return this.$store.state[`ui/sso`].ssoToken; },
      set(value) { this.$store.commit(`ui/sso/SET_SSO_TOKEN`, value); },
    },
    destPath: {
      get() { return this.$store.state[`ui/sso`].destPath; },
      set(value) { this.$store.commit(`ui/sso/SET_DEST_PATH`, value); },
    },
  },

  methods: {
    goNext() {
      this.$router.replace(this.destPath);
    },
  },

  async beforeMount() {
    this.ssoToken = _.trim(this.$route.query?.token || ``);
    this.destPath = decodeURIComponent(this.$route.query?.r || `/`);
    this.logout = parseInt(this.$route.query?.logout, 10) !== 0;

    if (this.logout) {
      await this.$store.dispatch(`model/auth/logout`);
    }

    if (this.ssoToken && !this.accessToken) {
      await this.$store.dispatch(`ui/sso/login`);
    }

    if (!this.accessToken) {
      this.$router.replace({ name: `login`, ...(this.destPath === `/data-exports` ? { query: { redirect: `/data-exports` } } : {}) });
    } else {
      this.goNext();
    }
  },
};
</script>

<style lang="scss">
</style>
